<template>
  <div>
    <!--滑块验证图片-->
    <div v-loading="imgLoading" style="position: relative">
      <img style="position: absolute;width: auto;z-index: 999;" :style="{top,left}" :src="smallImage" alt="">
      <img :src="bigImg" alt="">
    </div>
    <div />
    <div>
      <el-slider v-model="xValue" :max="250" @change="$emit('login',authKey, xValue)" />
    </div>
  </div>
</template>

<script>
import homeApi from '@/api/home'

export default {
  name: 'Index',
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      imgLoading: false,
      bigImg: null,
      smallImage: null,
      yHeight: 0,
      xValue: 0,
      authKey: null
    }
  },
  computed: {
    top() {
      return `${this.yHeight}px`
    },
    left() {
      return `${this.xValue}px`
    }
  },
  watch: {
    value(val) {
      this.$set(this, 'xValue', val)
    },
    xValue(val) {
      this.$emit('input', val)
    }
  },
  mounted() {
    // this.getImage()
  },
  methods: {
    getImage() {
      this.imgLoading = true
      homeApi.getSlideImage().then(res => {
        const { bigImage, smallImage, yHeight, authKey } = res
        this.$set(this, 'bigImg', `data:image/jpeg;base64,${bigImage}`)
        this.$set(this, 'smallImage', `data:image/jpeg;base64,${smallImage}`)
        this.$set(this, 'yHeight', yHeight)
        this.$set(this, 'authKey', authKey)
      }).finally(() => {
        this.$set(this, 'xValue', 0)
        this.imgLoading = false
      })
    },
    getContractSlideImage() {
      this.imgLoading = true
      homeApi.getContractSlideImage().then(res => {
        const { bigImage, smallImage, yHeight, authKey } = res
        this.$set(this, 'bigImg', `data:image/jpeg;base64,${bigImage}`)
        this.$set(this, 'smallImage', `data:image/jpeg;base64,${smallImage}`)
        this.$set(this, 'yHeight', yHeight)
        this.$set(this, 'authKey', authKey)
      }).finally(() => {
        this.$set(this, 'xValue', 0)
        this.imgLoading = false
      })
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/expertRegister/components/slideImg/index.vue